// extracted by mini-css-extract-plugin
export default {"alert":"AlertModal_alert__yTcGF","message":"AlertModal_message__-y7zL"};